import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index/index'
import privacyYy from '@/pages/privacy/privacy-yy.vue'
import privacyRy from '@/pages/privacy/privacy-ry.vue'
Vue.use(Router)
function getAbsolutePath () {
  let path = location.pathname
  return path.substring(0, path.lastIndexOf('/') + 1)
}
export default new Router({
  mode: 'history',
  base:getAbsolutePath(),
  routes: [{
    path: '/',
    name: 'index',
    component: index
  },
  {
    path: '/product',
    name: 'product',
    component: index
  },
  {
    path: '/company',
    name: 'company',
    component: index
  },
  {
    path: '/privacy-yy',
    name: 'privacy-yy',
    component: privacyYy
  },
  {
    path: '/privacy-ry',
    name: 'privacy-ry',
    component: privacyRy
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js